import React, { useState } from 'react'
import { AlertProvider } from './ghospital-mq/context/AlertContext';

import { Route, Routes } from 'react-router'

import { MqttProvider } from './ghospital-mq/context/MqttContext';

import PortalRootPage from './ghospital-mq/app/portal/pages/landing/PortalRootPage';
import PortalLandingPage from './ghospital-mq/app/portal/pages/landing/PortalLandingPage';
import SelectQueuePage from './ghospital-mq/app/portal/pages/checkin/SelectQueuePage';
import SelectServicesPage from './ghospital-mq/app/portal/pages/checkin/SelectServicesPage';
import CheckinFormPage from './ghospital-mq/app/portal/pages/checkin/CheckinFormPage';

import SelectScheduleQueuePage from './ghospital-mq/app/portal/pages/scheduleCheckin/SelectScheduleQueuePage';
import SelectScheduleServicesPage from './ghospital-mq/app/portal/pages/scheduleCheckin/SelectScheduleServicesPage';
import ScheduleCheckinFormPage from './ghospital-mq/app/portal/pages/scheduleCheckin/ScheduleCheckinFormPage';


import SelectSlotQueuePage from './ghospital-mq/app/portal/pages/slotCheckin/SelectSlotQueuePage';

import TokenDetailsPage from './ghospital-mq/app/portal/pages/TokenDetailsPage';
import SelectSlotServicesPage from './ghospital-mq/app/portal/pages/slotCheckin/SelectSlotServicesPage';
import SlotCheckinFormPage from './ghospital-mq/app/portal/pages/slotCheckin/SlotCheckinFormPage';
import FeedbackFormPage from './ghospital-mq/app/portal/pages/feedback/FeedbackFormPage';
import MqttChatPage from './ghospital-mq/app/mqtt/pages/MqttChatPage';
import NotificationListPage from './ghospital-mq/app/portal/pages/notification/pages/NotificationListPage';
import CustomerProfileListPage from './ghospital-mq/app/portal/pages/consultancy/pages/CustomerProfileListPage';
import ConsultancyListPage from './ghospital-mq/app/portal/pages/consultancy/pages/ConsultancyListPage';
import FollowUpListPage from './ghospital-mq/app/portal/pages/consultancy/pages/FollowUpListPage';






function App() {
    sessionStorage.removeItem("businessInfo");
    return (
        <>
        <AlertProvider>
            
            
                <Routes>
                    <Route path="/" element={ <PortalRootPage /> } />
                    <Route path="/portal/:portalId" element={ <PortalLandingPage/> } />

                    <Route path="/checkin/queue" element={ <SelectQueuePage/> } />
                    <Route path="/checkin/services" element={ <SelectServicesPage/> } />
                    <Route path="/checkin/form" element={ <MqttProvider><CheckinFormPage/></MqttProvider> } />

                    <Route path="/schedule-checkin/queue" element={ <SelectScheduleQueuePage /> } />
                    <Route path="/schedule-checkin/services" element={ <SelectScheduleServicesPage /> } />
                    <Route path="/schedule-checkin/form" element={ <MqttProvider><ScheduleCheckinFormPage /></MqttProvider> } />

                    <Route path="/slot-checkin/queue" element={ <SelectSlotQueuePage /> } />
                    <Route path="/slot-checkin/services" element={ <SelectSlotServicesPage /> } />
                    <Route path="/slot-checkin/form" element={ <MqttProvider><SlotCheckinFormPage /></MqttProvider> } />
                    
                    <Route path="/feedback-form" element={ <FeedbackFormPage/> } />
                    <Route path="/token-details" element={ <TokenDetailsPage/>  } />

                    <Route path="/notification-list" element={ <NotificationListPage/>  } />

                    <Route path="/customer-profiles" element={ <CustomerProfileListPage/>  } />
                    <Route path="/consultancy-list/:customerId" element={ <ConsultancyListPage/>  } />
                    <Route path="/followup-list" element={ <FollowUpListPage/>  } />

                    <Route path="/mqtt/chat" element={ <MqttProvider><MqttChatPage/></MqttProvider> } />
                </Routes>
            
        </AlertProvider>
        </>
    )
}
export default App




/*

<Routes>
    <Route path="/" element={ <PortalRootPage/> } />
    <Route path="/portal/:portalId" element={ <PortalLandingPage/> } />
    <Route path="/portal" element={ <SelectQueuePage/> } />
    <Route path="/schedule-checkin" element={ <SchecduleCheckin/> } />
    <Route path="/services/:queueId" element={ <SelectServicesPage/> } />
    <Route path="/checkin/:queueId/:serviceId" element={ <CheckinFormPage/> } />
    <Route path="/token-details" element={ <TokenDetailsPage/> } />
</Routes>

*/